export const hero = {
  eyebrow: '智慧农业解决方案',
  title: '把农田变成可被感知、可被管理的数字资产',
  desc: '华辉数智以 AIoT 为底座，围绕智慧农业平台、IoT 物联网连接平台、AI 数据中台、ePin 食安码，构建一套软硬件一体化的智慧农业解决方案',
  primaryLabel: '查看方案',
  secondaryLabel: '获取方案',
  image:
    'https://readdy.ai/api/search-image?query=Authentic%20documentary%20photograph%20of%20farmers%20working%20in%20a%20real%20planting%20field%2C%20rows%20of%20lush%20green%20vegetable%20crops%20and%20young%20seedlings%20growing%20in%20rich%20brown%20soil%20furrows%2C%20hands%20tending%20the%20plants%2C%20wide%20open%20farmland%20stretching%20to%20the%20horizon%2C%20soft%20golden%20sunrise%20light%20with%20gentle%20morning%20mist%2C%20warm%20natural%20green%20and%20earthy%20tones%2C%20realistic%20agricultural%20photography%2C%20cinematic%20depth%2C%20high%20detail&width=1600&height=900&seq=agri-hero-01&orientation=landscape&nocache=true',
  alt: '智慧农业解决方案',
  tags: ['终端感知', '网络连接', '数据智能', '业务应用'],
  twinTitle: '软硬一体四层架构',
  twinDesc: '终端感知 → 网络连接 → 数据智能 → 业务应用。',
  twinFlow: [
    { icon: 'ri-radar-line', label: '终端感知' },
    { icon: 'ri-cloud-line', label: '网络连接' },
    { icon: 'ri-brain-line', label: '数据智能' },
    { icon: 'ri-apps-2-line', label: '业务应用' },
  ],
};

export const painPoints = {
  eyebrow: '行业痛点与诉求',
  title: '农业行业的痛点与农户的核心诉求',
  subtitle: '把痛点讲清楚，才能把方案做到点子上——每张卡片上半是现状痛点，下半是农户真正想要的结果。',
  items: [
    {
      painTitle: '经验依赖',
      painDesc: '传统种植更多凭借个人经验，什么时候浇水、施多少肥、何时打药全靠感觉，对产量与品质缺乏科学的管理依据。',
      needTitle: '差异化农事作业方案',
      needDesc: '在作物生长的不同阶段，能够提供差异化的农事作业方案。',
    },
    {
      painTitle: '病虫害与灾害',
      painDesc: '无法实时掌握田间环境与作物长势，病虫害、旱涝冻害往往发现即成灾，防控窗口期被错过。',
      needTitle: '实时监测与及时预警',
      needDesc: '能实时监测作物与环境，在病虫害与灾害初期及时预警并给出处置建议。',
    },
    {
      painTitle: '成本与效率',
      painDesc: '灌溉、施肥、植保、巡田大量依赖人工投入，水肥药施用粗放，投入品浪费与用工成本居高不下。',
      needTitle: '规模化与轻量化两套方案',
      needDesc: '提供适合规模化基地与分散小农户的两套可行方案，降低单位投入。',
    },
  ],
};

export const capabilities = {
  eyebrow: '四项核心能力',
  title: '四项核心能力，构建绿色防控体系',
  subtitle: '从实时监控到环境调控，把农技人员的经验转化为可复用的模型与处方。',
  items: [
    {
      icon: 'ri-radar-line',
      title: '实时监控',
      desc: '实时采集田间环境信息，基于各类传感设备与视频终端，旱情、涝情、冻害、病虫害能够被及时预警并联动处置，把灾后补救变成灾前防控。',
    },
    {
      icon: 'ri-shield-star-line',
      title: '精准植保',
      desc: '基于实时数据，联动智能监测设备与大数据分析，把农技人员的经验转化为可复用的病虫害识别模型与植保处方，提供体系化的绿色防控解决方案，减少盲目用药。',
    },
    {
      icon: 'ri-water-flash-line',
      title: '自动灌溉施肥',
      desc: '传感器与智能装备在田间组网，农户可远程一键控制水肥一体机、灌溉阀与大棚设施，实现人工解放；同时灌溉施肥数据回流分析，持续优化投入产出比。',
    },
    {
      icon: 'ri-temp-cold-line',
      title: '环境调控',
      desc: '不同作物、不同生育期对环境的要求各不相同，大棚内通过运行参数的自动调整，创造最适合作物生长的温度、湿度、光照与二氧化碳环境，实现周年生产与错峰上市。',
    },
  ],
};

export const softwareModules = {
  eyebrow: '软件侧',
  title: '一套平台统管生产、品质与经营',
  subtitle: '从一张图到经营决策，八个核心模块覆盖农业生产的每一个关键环节。',
  items: [
    { icon: 'ri-map-2-line', title: '智慧农业一张图', desc: '农场数字地图，地块、大棚、设备、作物批次一屏统管。' },
    { icon: 'ri-seedling-line', title: '生产管理', desc: '种植计划、农事作业派发与回执、投入品台账、农机作业调度。' },
    { icon: 'ri-line-chart-line', title: '环境监控中心', desc: '多站点环境数据实时曲线、历史回放、同比环比分析。' },
    { icon: 'ri-alarm-warning-line', title: '智能预警中心', desc: '阈值告警、灾害模型预警、病虫害风险提示，短信 / 小程序 / 语音多通道触达。' },
    { icon: 'ri-settings-3-line', title: '自动控制中心', desc: '水肥一体机、灌溉阀、卷膜器、风机、补光灯的定时与联动策略执行。' },
    { icon: 'ri-brain-line', title: 'AI 分析引擎', desc: '作物长势识别、病虫害图像识别、产量预估、灌溉施肥建议生成。' },
    { icon: 'ri-qr-code-line', title: '品质溯源（ePin 食安码）', desc: '生产建档 → 批次 → 检测 → 赋码 → 仓储 → 运输 → 销售的全程数字档案。' },
    { icon: 'ri-bar-chart-box-line', title: '经营管理', desc: '订单、库存、结算与渠道数据，辅助经营决策。' },
  ],
  loop: {
    title: '软硬一体的关键：闭环而非堆叠',
    desc: '硬件负责把物理世界数字化，软件负责把数字变成决策，决策再通过控制器反向作用于物理世界。“感知 → 分析 → 决策 → 执行”形成闭环，这才是软硬件一体化的真正含义。',
    steps: [
      { icon: 'ri-radar-line', label: '感知' },
      { icon: 'ri-brain-line', label: '分析' },
      { icon: 'ri-flow-chart', label: '决策' },
      { icon: 'ri-play-circle-line', label: '执行' },
    ],
  },
};

export const topology = {
  eyebrow: '系统拓扑',
  title: '软硬件系统拓扑图',
  subtitle: '数据上得来、指令下得去、断网能自治、对外可贯通。',
  chain: [
    { icon: 'ri-radar-line', title: '田间终端', desc: '传感器 · 视频 · 控制器' },
    { icon: 'ri-wifi-line', title: '连接链路', desc: '4G Cat.1 / NB-IoT / LoRa' },
    { icon: 'ri-computer-line', title: '软件平台', desc: '监控软件 · PLC 组态屏' },
    { icon: 'ri-links-line', title: '华辉产品矩阵', desc: 'ePin 食安码 · 九畴云市 · 数字货架' },
  ],
  notes: [
    {
      icon: 'ri-upload-2-line',
      title: '上行链路',
      desc: '设备可通过 4G Cat.1、NB-IoT 或 LoRa 网关方式，将数据上传至监控软件平台或 PLC 组态屏；无市电点位支持太阳能 + 锂电供电方案。',
    },
    {
      icon: 'ri-download-2-line',
      title: '下行链路',
      desc: '平台下达的控制指令经同一链路回传至田间控制器，支持自动联动、定时计划、远程手动三种触发方式。',
    },
    {
      icon: 'ri-shield-flash-line',
      title: '边缘自治',
      desc: '断网时 PLC 组态屏仍可依据本地策略独立运行，网络恢复后数据自动补传，不丢数、不断控。',
    },
    {
      icon: 'ri-share-forward-line',
      title: '对外贯通',
      desc: '平台与 ePin 食安码、九畴云市、数字货架等华辉产品矩阵打通，实现从生产到县域销售渠道的数据贯通。',
    },
    {
      icon: 'ri-signal-tower-line',
      title: '连接保障',
      desc: '三网运营商背靠背的标准引擎：华辉蜂窝物联网卡与通信模组，保障田间弱网环境下的连接稳定性与资费可控。',
    },
  ],
};

export const hardware = {
  eyebrow: '硬件传感器产品',
  title: '从田间传感器到智能装备的完整终端矩阵',
  subtitle:
    '覆盖智能视觉监控、商用显示与智慧物联三大硬件门类，设备即插即用、可灵活扩展，所有参数与型号以项目最终选型清单为准。',
  categories: [
    {
      id: 'env',
      icon: 'ri-radar-line',
      name: '环境感知类',
      columns: ['设备', '监测要素', '典型指标', '安装要点'],
      rows: [
        ['土壤墒情传感器', '土壤体积含水量、土壤温度', '量程 0-100%', '分层埋设（20/40/60cm），每地块不少于 3 点'],
        ['土壤多参数传感器', '含水量、温度、EC 盐分、pH、氮磷钾', '多参数集成，支持 RS485 / LoRa', '根区布设，用于精准配肥'],
        ['空气温湿度传感器', '温度、相对湿度', '温度 ±0.3℃、湿度 ±3%RH', '百叶盒防辐射，大棚内多高度布点'],
        ['光照传感器', '光照强度、光合有效辐射', '0 ~ 200klx', '冠层高度安装，避免遮挡'],
        ['CO₂ 传感器', '二氧化碳浓度', '0 ~ 5000ppm，NDIR 红外原理', '大棚中部，配合通风联动'],
        ['小型农业气象站', '风速、风向、雨量、气压、温湿度、蒸发量', '一体化杆式安装', '园区开阔处，作为区域基准站'],
        ['水质传感器', 'pH、溶解氧、电导率、水温', '适用于灌溉水源与水产稻田', '蓄水池、回水口'],
      ],
    },
    {
      id: 'crop',
      icon: 'ri-bug-line',
      name: '作物与病虫害感知类',
      columns: ['设备', '功能说明', '应用特点'],
      rows: [
        ['虫情测报灯', '自动诱虫、拍照、计数上传', '结合 AI 识别实现虫口密度预警'],
        ['孢子捕捉仪', '空气中病原孢子捕捉、显微成像', '用于病害发生前期预报'],
        ['作物长势相机', '定时抓拍冠层图像', '用于株高、叶色、覆盖度 AI 分析'],
        ['AI 边缘识别终端', '本地病虫害 / 长势 / 入侵识别', '无需全量上传视频，节省流量'],
        ['智能视觉监控终端', '园区安全、人员作业、设备监管', '支持异常行为识别与录像留证'],
      ],
    },
    {
      id: 'control',
      icon: 'ri-settings-3-line',
      name: '控制执行类',
      columns: ['设备', '控制对象', '说明'],
      rows: [
        ['智能水肥一体机控制器', '灌溉泵、施肥泵、比例阀', '支持 EC/pH 闭环调节、多轮灌组轮换'],
        ['无线阀控器', '田间电动阀、电磁阀', 'LoRa 组网，单网关可管理数十路阀门'],
        ['大棚环境控制器', '卷膜 / 卷帘、风机、湿帘、补光', '按作物生育期自动执行环境曲线'],
        ['PLC 组态屏', '本地集中控制与可视化', '触摸屏就地操作，断网可用'],
        ['智能配电 / 用电监测', '机井、泵站用电与能耗', '用电异常告警，支撑能耗成本核算'],
      ],
    },
    {
      id: 'connect',
      icon: 'ri-dashboard-3-line',
      name: '连接与车载类',
      columns: ['设备', '通信方式', '应用场景'],
      rows: [
        ['LoRa 采集网关', 'LoRa + 4G 回传', '连栋温室、大面积大田自组网'],
        ['4G Cat.1 采集终端', '蜂窝直连', '分散点位、移动监测点'],
        ['NB-IoT 采集终端', '窄带低功耗', '电池供电的长期监测点'],
        ['农机车载终端', '北斗 / GPS + 4G', '作业轨迹、作业面积、深松深度、驾驶行为'],
        ['冷链车载终端', '北斗 / GPS + 温度采集', '运输途中的温湿度与位置全程可追溯'],
      ],
    },
  ],
  note: '说明：设备可采集环境温湿度、光照、土壤墒情等要素，并可根据实际应用新增传感器监控，所有参数与型号以项目最终选型清单为准。',
};

export const scenarios = {
  eyebrow: '农户应用场景',
  title: '五类农户应用场景，覆盖从建园到销售',
  subtitle: '无论是规模化基地还是分散小农户，都能找到合适的起步方式，轻量化建设、按需扩展。',
  items: [
    {
      id: 'agri-sc1',
      icon: 'ri-home-smile-line',
      tag: '场景一',
      title: '独立子系统',
      subtitle: '每户管理自己的“一亩三分地”',
      points: [
        '独立部署子系统，每一个农户均可控制自己的种植区（地块 / 大棚），数据彼此隔离、权限清晰。',
        '农户自有账号与独立的操作界面，互不干扰。',
        '合作社或运营方可查看汇总视图，实现“分散经营、统一管理”。',
        '分期建设：先上环境与溯源，再上自动控制和 AI 分析。',
      ],
    },
    {
      id: 'agri-sc2',
      icon: 'ri-alarm-warning-line',
      tag: '场景二',
      title: '智能预警与溯源追踪',
      subtitle: '预警到位、处置到田、产品可查',
      points: [
        '智能预警：旱涝、冻害、高温热害、病虫害风险分等级推送到手机。',
        '农事配套：预警同时附带处置方案（该不该灌、灌多少、用什么药、安全间隔期）。',
        '产品可溯源：接入 ePin 食安码，扫码可见产地、主体、日期、批次、检测结果、流通过程。',
        '分散投入：以户为单位轻量化起步，减少一次性大额成本。',
      ],
    },
    {
      id: 'agri-sc3',
      icon: 'ri-equalizer-line',
      tag: '场景三',
      title: '个性化定制',
      subtitle: '按自家地块与作物，定时定点执行',
      points: [
        '支持个性化灌溉施肥方式，由农户根据自家地块情况、作物类型与生育期执行作业策略。',
        '按作物自定义环境阈值与控制联动规则。',
        '支持“我的方案”保存复用，一年配置、多年沿用。',
        '既支持全自动执行，也支持半自动确认，农户掌握最终决定权。',
      ],
    },
    {
      id: 'agri-sc4',
      icon: 'ri-remote-control-line',
      tag: '场景四',
      title: '预警分析与远程农技',
      subtitle: '云端获取分析，由“跑田”变“看图”',
      points: [
        '预警信息及智能分析实时云端获取。',
        '云端统计算区内的病虫害发生趋势、土壤墒情变化。',
        '区域农技人员可远程查看多个农户地块，由“跑田”变“看图”。',
        '历史数据沉淀形成本地化的作物知识库，逐年调优。',
      ],
    },
    {
      id: 'agri-sc5',
      icon: 'ri-store-3-line',
      tag: '场景五',
      title: '数据管理与经营衔接',
      subtitle: '生产数据，不止服务于生产',
      points: [
        '农事台账：播种、施肥、灌溉、植保、采收全程留痕，成为绿色认证与品牌背书的数据基础。',
        '成本台账：投入品、用工、能耗按地块核算单亩成本与收益。',
        '经营衔接：对接九畴云市、数字货架与县域商业渠道，让好产品直接对接好渠道。',
      ],
    },
  ],
};

export const digitalId = {
  eyebrow: '农产品数字身份证',
  title: '重点打造一个“农产品数字身份证”',
  subtitle: '一物一码，全程可追溯。让每一件农产品都拥有一份从生产到消费的数字档案。',
  qrTitle: '扫码查看全程溯源档案',
  qrHint: '微信扫一扫，查看「清远鸡」从养殖到消费的完整数字记录。',
  qrContent: `清远鸡 · 农产品数字身份证（一物一码 · 全程可追溯）
01 生产主体
02 养殖基地
03 养殖批次
04 养殖过程
05 质量检测
06 包装赋码
07 入仓
08 冷链运输
09 市场销售
10 消费者扫码`,
  exampleLabel: '以「清远鸡」为例',
  steps: [
    { icon: 'ri-building-2-line', label: '生产主体' },
    { icon: 'ri-home-smile-line', label: '养殖基地' },
    { icon: 'ri-price-tag-3-line', label: '养殖批次' },
    { icon: 'ri-seedling-line', label: '养殖过程' },
    { icon: 'ri-shield-check-line', label: '质量检测' },
    { icon: 'ri-qr-code-line', label: '包装赋码' },
    { icon: 'ri-inbox-archive-line', label: '入仓' },
    { icon: 'ri-truck-line', label: '冷链运输' },
    { icon: 'ri-store-3-line', label: '市场销售' },
    { icon: 'ri-smartphone-line', label: '消费者扫码' },
  ],
  scanTitle: '消费者扫码可见',
  scanItems: [
    { icon: 'ri-map-pin-2-line', label: '产地' },
    { icon: 'ri-building-2-line', label: '生产主体' },
    { icon: 'ri-calendar-line', label: '生产日期' },
    { icon: 'ri-price-tag-3-line', label: '批次' },
    { icon: 'ri-shield-check-line', label: '检测结果' },
    { icon: 'ri-route-line', label: '流通过程' },
    { icon: 'ri-information-line', label: '产品信息' },
  ],
};

export const values = {
  eyebrow: '方案价值',
  title: '从传统种植到智慧农业',
  subtitle: '同一个环节，两种做法——智慧农业方案把凭经验、靠人工的方式，变成可感知、可管理、可追溯的数据能力。',
  columns: ['维度', '传统种植', '智慧农业方案'],
  rows: [
    ['环境感知', '人工巡田，凭经验判断', '全天候连续监测，异常自动告警'],
    ['灌溉施肥', '大水漫灌、粗放施肥', '按需精准水肥，节水节肥并提升品质'],
    ['病虫害防控', '发现即成灾', '测报预警，防在未发、治在初发'],
    ['用工投入', '巡田、开关阀、操作设备全靠人', '远程控制与自动化执行，人工大幅解放'],
    ['农事管理', '纸质或记忆记录', '全程电子台账，可复盘、可核算'],
    ['产品销售', '缺乏凭据，只能按原料销售', 'ePin 溯源赋码，支撑品牌化经营'],
    ['经营决策', '凭感觉判断', '基于生产、库存、销售数据分析决策'],
  ],
  summary:
    '一句话总结：华辉数智智慧农业解决方案，用软硬件一体化把农田变成可被感知、可被管理的数据资产，再通过 ePin 溯源把它变成可被市场认可的品牌资产。',
};

export const traceDetail = {
  eyebrow: '农产品数字身份证 · 扫码核验',
  code: 'QYJ-2026-0908-0451',
  title: '清远鸡 · 全程溯源档案',
  highlight: '一物一码 · 从养殖到餐桌',
  subtitle: '您扫描的这枚溯源码由华辉数智智慧农业平台签发，养殖、检测、加工、仓储、冷链与销售全链路数据实时同步、不可篡改。',
  heroImage:
    'https://readdy.ai/api/search-image?query=Fresh%20free-range%20Qingyuan%20chicken%20in%20a%20clean%20modern%20free-range%20farm%20environment%20with%20lush%20green%20grass%2C%20a%20tablet%20displaying%20a%20traceability%20QR%20code%20and%20digital%20archive%20overlay%2C%20soft%20natural%20morning%20light%2C%20fresh%20green%20and%20earthy%20tones%2C%20professional%20agricultural%20food%20traceability%20editorial%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=900&seq=agri-trace-hero-01&orientation=landscape',
  heroAlt: '清远鸡农产品数字身份证溯源档案',
  verifyTitle: '正品已核验',
  verifyDesc: '本档案由清远市禾丰生态农业有限公司签发，并经华辉数智智慧农业平台存证，数据同步更新、全程可追溯。',
  metrics: [
    { value: '156 天', label: '生态养殖周期' },
    { value: '12 项', label: '质量检测项目' },
    { value: '0-4 ℃', label: '全程冷链温控' },
    { value: '10 个', label: '可追溯环节' },
  ],
  basicTitle: '产品基本信息',
  basic: [
    { label: '产品名称', value: '清远麻鸡（冰鲜整鸡）' },
    { label: '溯源码', value: 'QYJ-2026-0908-0451' },
    { label: '生产主体', value: '清远市禾丰生态农业有限公司' },
    { label: '养殖基地', value: '广东省清远市清城区飞来峡生态养殖基地' },
    { label: '养殖批次', value: '2026-0812 批次（3,200 只）' },
    { label: '出栏日期', value: '2026-09-06' },
    { label: '包装日期', value: '2026-09-08' },
    { label: '储存方式', value: '0-4 ℃ 冷藏，保质期 7 天' },
  ],
  inspectionTitle: '质量检测结果',
  inspectionNote: '委托第三方检测机构检测，报告编号 GDJC-2026-0912-0087。',
  inspections: [
    { name: '兽药残留（氟喹诺酮类）', result: '合格', std: '未检出' },
    { name: '兽药残留（磺胺类）', result: '合格', std: '未检出' },
    { name: '氯霉素', result: '合格', std: '未检出' },
    { name: '沙门氏菌', result: '合格', std: '未检出' },
    { name: '金黄色葡萄球菌', result: '合格', std: '未检出' },
    { name: '挥发性盐基氮', result: '合格', std: '符合 GB 2707' },
  ],
  stepsTitle: '全程溯源记录',
  stepsSubtitle: '从生产主体建档到消费者扫码，每一环都有时间、有记录、有责任人。',
  steps: [
    {
      icon: 'ri-building-2-line',
      label: '生产主体',
      desc: '养殖主体完成平台注册备案，营业执照、动物防疫条件合格证等资质齐全。',
      time: '2026-03-02',
    },
    {
      icon: 'ri-home-smile-line',
      label: '养殖基地',
      desc: '基地地理坐标、栏舍编号、存栏规模完成数字化建档，纳入平台统一管理。',
      time: '2026-03-05',
    },
    {
      icon: 'ri-price-tag-3-line',
      label: '养殖批次',
      desc: '本批次共 3,200 只，建立电子养殖档案，绑定唯一批次编号。',
      time: '2026-08-12',
    },
    {
      icon: 'ri-seedling-line',
      label: '养殖过程',
      desc: '持续记录饮水、饲喂、防疫、用药与栏舍温湿度数据，形成生长曲线。',
      time: '2026-08-12 至 09-05',
    },
    {
      icon: 'ri-shield-check-line',
      label: '质量检测',
      desc: '委托第三方检测机构对兽药残留与微生物指标进行检测，12 项全部合格。',
      time: '2026-09-06',
    },
    {
      icon: 'ri-qr-code-line',
      label: '包装赋码',
      desc: '屠宰加工后按只赋码，一物一码并绑定溯源码，防止串码与套码。',
      time: '2026-09-08',
    },
    {
      icon: 'ri-inbox-archive-line',
      label: '入仓',
      desc: '冷链仓库入库，记录库位、入库温度与操作人员信息。',
      time: '2026-09-08',
    },
    {
      icon: 'ri-truck-line',
      label: '冷链运输',
      desc: '全程 0-4 ℃ 冷链运输，车载终端实时上传位置与温度数据。',
      time: '2026-09-09',
    },
    {
      icon: 'ri-store-3-line',
      label: '市场销售',
      desc: '配送至商超与电商前置仓，销售去向可查询、可追溯。',
      time: '2026-09-10',
    },
    {
      icon: 'ri-smartphone-line',
      label: '消费者扫码',
      desc: '消费者扫码查看完整档案，并可通过平台核验产品真伪。',
      time: '实时',
    },
  ],
  footerNote: '本档案数据由智慧农业平台实时同步 · 一物一码 · 数据不可篡改',
};